import { createUseStyles } from "react-jss";
import { EuiFlexItem, EuiAccordion, EuiProgress } from "@elastic/eui";
import { COLORS } from "Consts";

export const accordionStyles = createUseStyles({
  accordion_box: {
    border: `1px solid var(--border-color)`,
    borderRadius: "var(--box-radius)",
    padding: "8px 0px",
    width: "100%",
    backgroundColor: "var(--accordion)",
  },
  accordion_box_with_highlight: {
    border: `1px solid var(--border-color)`,
    borderLeft: (props: any) => `4px solid ${props.highlightColor || "var(--green)"}`,
    borderRadius: "var(--box-radius)",
    padding: "8px 0px",
    width: "100%",
    background: "var(--app-background)",
  },
  accordion: {
    "& .euiAccordion__buttonContent": {
      width: "100%",
      textDecoration: "none !important",
    },
    "& .euiAccordion__children": {
      padding: 0,
      paddingTop: "8px",
    },
    "& .euiAccordion__triggerWrapper": {
      padding: "0px 14px",
    },
    "& .euiAccordion__iconButton": {
      backgroundColor: "transparent",
    },
    "& .euiAccordion__button": {
      textDecoration: "none !important",
    },
  },
  content: {
    borderTop: `1px solid var(--border-color)`,
    width: "100%",
    padding: "14px",
  },
});

interface AccordionProps {
  type?: string | number;
  loading?: boolean;
  forceState?: "closed" | "open" | undefined;
  onToggle: any;
  initialIsOpen?: boolean;
  buttonContent: any;
  children: any;
  style?: any;
  highlight?: boolean;
  highlightColor?: string;
}

const Accordion = ({
  type,
  loading,
  forceState,
  onToggle,
  initialIsOpen,
  buttonContent,
  children,
  style,
  highlight = false,
  highlightColor = "var(--green)",
}: AccordionProps) => {
  const classes = accordionStyles({ highlightColor });

  return (
    <EuiFlexItem
      className={highlight ? classes.accordion_box_with_highlight : classes.accordion_box}
      style={style}>
      <div style={{ position: "relative" }}>
        {loading && (
          <div style={{ position: "absolute", top: "48px", width: "100%" }}>
            <EuiProgress size="xs" color={COLORS.$progressBlue} />
          </div>
        )}
        <EuiAccordion
          id={`accordion-${type}`}
          className={classes.accordion}
          initialIsOpen={initialIsOpen}
          onToggle={onToggle}
          forceState={forceState}
          buttonContent={buttonContent}
          paddingSize="m">
          <div className={classes.content}>{children}</div>
        </EuiAccordion>
      </div>
    </EuiFlexItem>
  );
};

export default Accordion;
